import ImageService from 'src/modules/image/imageService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'IMAGE_VIEW';

const imageViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: imageViewActions.FIND_STARTED,
      });

      const record = await ImageService.find(id);

      dispatch({
        type: imageViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: imageViewActions.FIND_ERROR,
      });

      navigateTo('/library/image');
    }
  },
};

export default imageViewActions;
